// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1v6op","info":"UpdateTermsInfo_info__2IQlN"};